// removed by extract-text-webpack-plugin
module.exports = {"expand":"_1Bo7i1rGAsHsmXNbWBVvwE","head":"oESqDivO-FP8wYkd6H8JU","title":"_1Q_X2OTmoi_Upgu8dA15ZK","right":"_28XkC7mRzXHOIot0LK6i4i","btn":"ITqYtXrLmzM4wDV5ndI6b","content":"_2hGZOEj6FqTkLIGqaZyJop","hide":"_3Si8HjyeUWSu5T8sp1agp-","borderBottomRadiusNone":"ET156kqzfroqgf2LnrSlp","borderTopRadius":"_2xi7Z_aZWYrRF5-18rvq0Z","borderBottomRadius":"_28W7oVCY_JaRvo2H9lGGph","borderBottom":"_1lWCe61P73SgCVBDV2mnHG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/Expand.scss
// module id = 448
// module chunks = 0